import CONSTANTS from '../constants';
import CartService from '../services/CartService';

export function updateCart(history = {}) {
  return async (dispatch) => {
    try {
      dispatch({ type: CONSTANTS.ACTIONS.CART.UPDATE, cart: CartService.getCart() });
    } catch (error) {
      console.log('Error: ', error);
    }
  };
}

export function clearCart(history = {}) {
  return async (dispatch) => {
    try {
      dispatch({ type: CONSTANTS.ACTIONS.CART.UPDATE, cart: [] });
    } catch (error) {
      console.log('Error: ', error);
    }
  };
}
